// routes
// components
import SvgIconStyle from '../../../minimals/SvgIconStyle';
import { generatePath } from 'react-router';
import { PATH_WORKSPACE } from '../../../routes/paths';
import I18n from '../../../i18n/index';
import Devices from '@mui/icons-material/Devices';
import HistoryIcon from '@mui/icons-material/History';
import AssessmentIcon from '@mui/icons-material/Assessment';
// ----------------------------------------------------------------------

const getIcon = (name) => (
  <SvgIconStyle
    src={`/static/icons/navbar/${name}.svg`}
    sx={{ width: '100%', height: '100%' }}
  />
);

export const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  devices: <Devices />,
  reports: <AssessmentIcon />,
  kanban: getIcon('ic_kanban'),
  banking: getIcon('ic_banking'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  booking: getIcon('ic_booking'),
  businessman: getIcon('ic_businessman'),
  marker: getIcon('ic_marker'),
};

const sidebarConfig = ({ workspaceId }) => [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'general',
    items: [
      {
        title: I18n.t('sidebar.dashboard_tab_title'),
        path: generatePath(PATH_WORKSPACE.dashboard, { workspaceId }),
        icon: ICONS.dashboard,
      },
      {
        title: I18n.t('sidebar.monitoring_tab_title'),
        path: generatePath(PATH_WORKSPACE.monitoring.root, { workspaceId }),
        icon: ICONS.analytics,
        props: {
          target: '_blank',
        },
      },
      {
        title: I18n.t('sidebar.traffic_tab_title'),
        path: generatePath(PATH_WORKSPACE.traffic.root, { workspaceId }),
        icon: <HistoryIcon />,
        props: {
          target: '_blank',
        },
      },
      {
        title: I18n.t('sidebar.customers_tab_title'),
        path: generatePath(PATH_WORKSPACE.customers.root, { workspaceId }),
        icon: ICONS.businessman,
      },
      {
        title: I18n.t('sidebar.devices_tab_title'),
        path: generatePath(PATH_WORKSPACE.devices.root, { workspaceId }),
        icon: ICONS.devices,
      },
      {
        title: I18n.t('sidebar.reports_tab_title'),
        path: generatePath(PATH_WORKSPACE.reports.root, { workspaceId }),
        icon: ICONS.reports,
      },
      {
        title: I18n.t('sidebar.invoices_tab_title'),
        path: generatePath(PATH_WORKSPACE.invoices.root, { workspaceId }),
        icon: ICONS.banking,
      },
      {
        title: I18n.t('sidebar.places_tab_title'),
        path: generatePath(PATH_WORKSPACE.places.root, { workspaceId }),
        icon: ICONS.marker,
      },
      {
        title: I18n.t('sidebar.service_orders_tab_title'),
        path: generatePath(PATH_WORKSPACE.serviceOrders.root, { workspaceId }),
        icon: ICONS.booking,
      },
    ],
  },
];

export default sidebarConfig;
